import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import moment from "moment";
import Header from "./Header";
import Sidebar from "./Sidebar";
import FeatherIcon from "feather-icons-react";
import CandidateTab from "./CandidateTab";
import { toast } from "react-toastify";
import NotificationPanels from "./NotificationPanels";
import { getEmailVerify, getGenderListonPrefix, getUANVerify } from "../Actions/personalDetailsActions";
import "../assets/css/candidate-tab-form.css";
import "../clinetAssets/css/duplicate-modal.css";
import {
  validateEmail,
  validateMobileNumber711,
  validateMobileNumber,
  differenceInTime,
  validateAlphabetsAndSpace,
  dateFormat,
  validateMobileNumber10Digits,
  validateUAN,
  validatePAN,
} from "../Helper/common";
import InputField from "./InputField";
import {
  getPersonalDetails,
  sendPersonalDetails,
  uploadFileViaMultipart,
  deleteSavePersonalDetails,
} from "../Actions/personalDetailsActions";
import GetMasterData from "../Helper/masterData";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Loader from "./Common/loader";
import Footer from "./Footer.js";
import StepCount from "./Common/StepCount";
import ConfirmationPopup from "./EmploymentForm/confirmationPopup";
import EMPCheckbox from "./EmploymentForm/empCheckbox";
import EMPRadio from "./EmploymentForm/empRadio";
import { getProfileFields } from "../Actions/profileFieldsAction";
import {
  getSavePersonalDetailByclient,
  deletePersonalDetailByClientData,
} from "../Actions/personalDetailByClientAction";
import { merge } from "jquery";
import CandidateTabClient from "./CandidateTabClient";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import "../clinetAssets/css/duplicate-modal.css";
import { saveCanidateDetail } from "../Actions/duplicityIgnoreAction";
import {
  getVerifyCompleted,
  deleteVerifyCompleted,
} from "../Actions/personalDetailsActions";
import ImagePopup from "./ImagePopup.js";
import ProgressHeading from "./Common/ProgressHeading.jsx";
//import { getDuplicityDiscard } from "../Actions/duplicityDiscardAction";
const nonEditableFieldsAfterFirstSave = [
  //   "first_name",
  //   "middle_name",
  //   "last_name",
  //   "email_address",
];

const CandidatePersonalDetailByClient = () => {
  const navigate = useNavigate();
  const getInputType = {
    1: "text",
    2: "textarea",
    3: "checkbox",
    4: "text",
    5: "radio",
    6: "hidden",
    7: "date",
    8: "file",
  };

  const [personalDetails, setPersonalDetails] = useState({});

  const [inputFormData, setInputFormData] = useState({});

  const [unsavedData, setUnsavedData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [Id, setId] = useState();
  const [errorData, setErrorData] = useState({});
  const [personalComplete, setPersonalComplete] = useState();
  const [inputFields, setInputFields] = useState([]);
  const [emailId, setEmailId] = useState("");
  const [minorCandidate, setMinorCandidate] = useState(false);
  const [authComplete, setAuthComplete] = useState(0);
  const [dateOfMarriageApplicable, setDateOfMarriageApplicable] =
    useState(false);
  const [mappingArray, setMappingArray] = useState([]);
  const [customMappingArray, setCustomMappingArray] = useState([]);
  const [isFileUploadedObject, setIsFileUploadedObject] = useState({});
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [popupMsg, setPopupMsg] = useState("");
  const [uploadedFileKey, setUploadedFileKey] = useState(null);
  const [consentIsChecked, setConsentIsChecked] = useState(false);
  const [role, setRole] = useState();
  const [emailErr, setEmailErr] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState();
  const [duplicateCase, setDuplicateCase] = useState([]);
  const [isDuplicateModal, setDuplicateModal] = useState(false);
  const storeData = useSelector((state) => state.profileFields);
  const storeData2 = useSelector((state) => state.savedPersonalDetails);
  const storeData3 = useSelector((state) => state.savedFileDetails);
  const [verify, setVerify] = useState(false);
  const [verifyComplete, setVerifyComplete] = useState(false);
  const [uanVerificationData, setUanVerificationData] = useState(null);
  const [updatedGenderData, setUpdatedGenderData] = useState(null);
  const storeProfileFieldsData =
    useSelector((state) => state.profileFields) || {};
  const dispatch = useDispatch();
  const { personalDetailsData, loading: getDataLoading, error } = storeData;
  const {
    profileFieldsData,
    loading: getprofileFieldsLoading,
    errorProfileFields,
  } = storeProfileFieldsData;
  const { savePersonalDetailsData } = storeData2;
  const { saveFileUploadData } = storeData3;
  const storeData4 = useSelector((state) => state.verifyEmail);
  const storeData5 = useSelector((state) => state.verifyCompleted);
  const storePersonalDetailByClientData = useSelector(
    (state) => state.personalDetailByClient
  );
  const {
    verifyCompletedData,
    loading: getVerifyCompletedLoading,
    erro,
  } = storeData5;
  const {
    personalDetailByClientData,
    loading: loadingFileUpload,
    error: errorFileUpload,
  } = storePersonalDetailByClientData;

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loading } = autoLoginStore;
  const { verifyEmailData, loading: getEmailLoading, err } = storeData4;

  const [modalImage, setModalImage] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);


  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }
  const userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

  const nameFields = [
    "first_name",
    "middle_name",
    "last_name",
  ];

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      setReferenceNumber(autoLoginData?.data?.reference_number);
      setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  const storeLandingClientData = useSelector((state) => state.landingClient);
  const { landingClientData, loadingData, errorClientData } =
    storeLandingClientData;
  useEffect(() => {
    if (typeof loadingData !== "undefined" && loadingData !== null) {
      if (loadingData === true) {
        //   setIsLoading(true);
      } else {
        // setIsLoading(false);
      }
    }
  }, [landingClientData]);

  useEffect(() => {
    if (typeof getEmailLoading !== "undefined" && getEmailLoading !== null) {
      if (getEmailLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [getEmailLoading]);

  useEffect(() => {
    if (
      typeof verifyCompletedData !== "undefined" &&
      verifyCompletedData !== null
    ) {
      if (verifyCompletedData?.data?.isVerified == 1) {
        checkBeforeSave(true);
      } else if (verifyCompletedData?.data?.isVerified == 0) {
        checkBeforeSave(false);
      }
    }
  }, [verifyCompletedData, storeData5]);

  useEffect(() => {
    if (typeof verifyEmailData !== "undefined" && verifyEmailData !== null) {
      if (verifyEmailData.status == "success") {
        setVerifyComplete(true);
      } else if (
        verifyEmailData.message ==
        "something went wrong while initiating e-mail!"
      ) {
        let errorMsg = "Invalid email entered";
        toast.error(errorMsg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  }, [verifyEmailData, storeData4]);

  const handleVerify = (val, e) => {
    e.preventDefault();
    let record = {};
    if (val == "") {
      let errorMsg = "Please enter email first";
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    } else {
      record.email = val;
      record.case_id = profileFieldsData?.data?.ini_case_id;
      record.reference_number = referenceNumber;
      dispatch(getEmailVerify(record));
    }
  };

    const handleUANVerification = (val, e) => {
      e.preventDefault();
      const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
      setIsLoading(true);
      dispatch(getUANVerify({uan_number: val, reference_id: reference}, getUANverificationResponse));
    }
  
    const getUANverificationResponse = (data) => {
      //success response
      setIsLoading(false);
      const demoData = {
        "status": "success",
        "code": 200,
        "data": {
            "status": "success",
            "msg": "Uan number has been verified successfully",
            "api_hit_count": 0
        }
    }
    setUanVerificationData(data);
      console.log("response data ", data)
    }

  useEffect(() => {
    if (
      typeof landingClientData?.data !== "undefined" &&
      landingClientData?.data !== null
    ) {
      if (landingClientData.data.authrize_complete == 0) {
        navigate("/candidate-form/authorization");
      }
      setAuthComplete(landingClientData.data.authrize_complete);
      setPersonalComplete(landingClientData.data.personal_completed);
    }
  }, [landingClientData, storeLandingClientData]);

  useEffect(() => {
    console.log("df", inputFields);
    console.log("ds", inputFormData);
  });

  useEffect(() => {
    if (
      typeof personalDetailByClientData?.status !== "undefined" &&
      personalDetailByClientData?.status !== null
    ) {
      if (personalDetailByClientData?.status == "success") {
        if (
          typeof personalDetailByClientData.data.group !== "undefined" &&
          personalDetailByClientData.data.group !== null && personalDetailByClientData.data.group?.group_id !== "profile_preview"
        ) {
          navigate(
            `../../case-initiation/check-detail/${personalDetailByClientData.data.reference_number}/${personalDetailByClientData.data.group?.group_id}`
          );
          dispatch(deletePersonalDetailByClientData());
          setDuplicateModal(false);
        } else {
          refresh();
          navigate(
            `/case-initiation/profile-preview/${personalDetailByClientData.data.reference_number}`
          );
        }
      }
      if (personalDetailByClientData?.status == "error") {
        const duplicateCase =
          personalDetailByClientData.data.duplicate_records.iBridgeduplicity ||
          [];
        setDuplicateCase(duplicateCase);

        console.log(inputFormData);
        setDuplicateModal(true);

        // navigate("/candidate-form/duplicity");
        // dispatch(deletePersonalDetailByClientData());
      }
    }
  }, [personalDetailByClientData, storePersonalDetailByClientData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const discardCase = () => {
    setDuplicateModal(false);
  };
  const ignoreDuplicate = () => {
    saveProfileDetails("ignore");
  };

  useEffect(() => {
    if (typeof getDataLoading !== "undefined" && getDataLoading !== null) {
      if (getDataLoading === true) {
        //  setIsLoading(true);
      } else {
        //setIsLoading(false);
      }
    }
  }, [personalDetailsData]);

  useEffect(() => {
    if (
      typeof profileFieldsData?.data !== "undefined" &&
      profileFieldsData?.data !== null
    ) {
      setId(profileFieldsData?.data?.case_id);

      refresh();
      // setFlexFields(flexFields);
    }
  }, [profileFieldsData]);

  useEffect(() => {
    if (
      typeof profileFieldsData?.data !== "undefined" &&
      profileFieldsData?.data !== null
    ) {
      if (profileFieldsData.data.isVerifyEmail == 1) {
        setVerify(true);
      }
      let mobileCodeIndex = null;
      let mobileCodeValue = null
      let alternateMobileCodeIndex = null;
      let alternateMobileCode = null;

      if(profileFieldsData?.data?.fields) {
        let fields = profileFieldsData?.data?.fields;
        for (let key in fields) {
          if(fields[key] && fields[key]?.field_name === "mobile_code"){
            mobileCodeIndex = key ;
            mobileCodeValue = fields[key]?.value
          }

          if(fields[key] && fields[key]?.field_name === "alternate_mobile_country_code"){
            alternateMobileCodeIndex = key ;
            alternateMobileCode = fields[key]?.value
          }

        }
      }
      if(profileFieldsData?.data?.fields[alternateMobileCodeIndex] && mobileCodeValue) {
        profileFieldsData.data.fields[alternateMobileCodeIndex].value = mobileCodeValue // wrong manupulation ..should get handle in api 
      }

      for (
        let i = 0;
        i < Object.keys(profileFieldsData?.data?.fields)?.length;
        i++
      ) {
        if (
          profileFieldsData?.data?.fields[
            Object.keys(profileFieldsData?.data?.fields)[i]
          ]?.field_name === "email_address"
        ) {
          setEmailId(
            profileFieldsData?.data?.fields[
              Object.keys(profileFieldsData?.data?.fields)[i]
            ]?.value
          );
        }

        if (
          profileFieldsData?.data?.fields[
            Object.keys(profileFieldsData?.data?.fields)[i]
          ]?.field_name === "date_of_birth"
        ) {
          localStorage.setItem('dob',  profileFieldsData?.data?.fields[
            Object.keys(profileFieldsData?.data?.fields)[i]
          ]?.value)
        }

        if(
          profileFieldsData?.data?.fields[
            Object.keys(profileFieldsData?.data?.fields)[i]
          ]?.field_name === "prefix" && profileFieldsData?.data?.fields[
            Object.keys(profileFieldsData?.data?.fields)[i]
          ]?.value
        ) {
          const prefixValue = profileFieldsData?.data?.fields[
            Object.keys(profileFieldsData?.data?.fields)[i]
          ]?.value
          dispatch(getGenderListonPrefix({option: prefixValue}, updatedGenderDataCallback))
        }

      }

      if (Object.keys(unsavedData).length === 0) {
        setPersonalDetails(profileFieldsData.data);
        createErrorData(profileFieldsData.data);
        setPersonalDataForMapping(profileFieldsData.data);
        createIsFileUploadedObject(profileFieldsData.data.fields);
      } else {
        const unsavedDataArr = _.cloneDeep(unsavedData);
        const newDataFields = _.cloneDeep(profileFieldsData.data.fields);
        const unsavedDataFields = _.cloneDeep(unsavedData.fields);
        let newParentalConsent = null;
        let parentalConsentIndex = null;
        for (let i = 0; i < newDataFields.length; i++) {
          if (newDataFields[i].field_name === "parental_consent_file") {
            newParentalConsent = _.cloneDeep(newDataFields[i]);
          }
        }
        for (let j = 0; j < unsavedDataFields.length; j++) {
          if (unsavedDataFields[j].field_name === "parental_consent_file") {
            parentalConsentIndex = j;
          }
        }
        if (parentalConsentIndex) {
          unsavedDataFields[parentalConsentIndex] =
            _.cloneDeep(newParentalConsent);
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }

        //
        let newCV = null;
        let cvIndex = null;
        for (let i = 0; i < newDataFields.length; i++) {
          if (newDataFields[i].field_name === "cv_document_file") {
            newCV = _.cloneDeep(newDataFields[i]);
          }
        }
        for (let j = 0; j < unsavedDataFields.length; j++) {
          if (unsavedDataFields[j].field_name === "cv_document_file") {
            cvIndex = j;
          }
        }
        if (cvIndex) {
          unsavedDataFields[cvIndex] = _.cloneDeep(newCV);
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }
        let newCovid = null;
        let covidIndex = null;  
        
        for (let i = 0; i < newDataFields.length; i++) {
          if (newDataFields[i].field_name === "covid_vaccine_file") {
            newCovid = _.cloneDeep(newDataFields[i]);
          }
        }
        for (let j = 0; j < unsavedDataFields.length; j++) {
          if (unsavedDataFields[j].field_name === "covid_vaccine_file") {
            covidIndex = j;
          }
        }
        if (covidIndex) {
          unsavedDataFields[covidIndex] =
            _.cloneDeep(newCovid);
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }

        let newform16 = null;
        let form16Index = null;  
        
        for (let i = 0; i < newDataFields.length; i++) {
          if (newDataFields[i].field_name === "form_16_file") {
            newform16 = _.cloneDeep(newDataFields[i]);
          }
        }
        for (let j = 0; j < unsavedDataFields.length; j++) {
          if (unsavedDataFields[j].field_name === "form_16_file") {
            form16Index = j;
          }
        }
        if (form16Index) {
          unsavedDataFields[form16Index] =
            _.cloneDeep(newform16);
          unsavedDataArr.fields = _.cloneDeep(unsavedDataFields);
          setUnsavedData(unsavedDataArr);
          setPersonalDetails(unsavedDataArr);
          createErrorData(unsavedDataArr);
          setPersonalDataForMapping(unsavedDataArr);
          createIsFileUploadedObject(unsavedDataArr.fields);
        }
      }
    }
  }, [profileFieldsData, storeProfileFieldsData]);

  useEffect(() => {
    const hasReferenceNumber =
      savePersonalDetailsData && savePersonalDetailsData.data ? true : false;
    if (hasReferenceNumber) {
      if(savePersonalDetailsData.data.group.group_id == 'profile_preview'){
         navigate(`/case-initiation/profile-preview/${savePersonalDetailsData.data.reference_number}`);
      }else{
        navigate(
          `/case-initiation/check-detail/${savePersonalDetailsData.data.reference_number}/${savePersonalDetailsData.data.group.group_id}`
        );
      }
      //  dispatch(deleteSavePersonalDetails());
    }
  }, [savePersonalDetailsData, storeData2]);

  useEffect(() => {
    if (saveFileUploadData.data) {
      console.log("here...", uploadedFileKey);
      const updatedPersonalDetails = _.cloneDeep(personalDetails);
      for (var i in updatedPersonalDetails.fields) {
        const fieldName = updatedPersonalDetails.fields[i].field_name;
        if (fieldName === "cv_document_file" && uploadedFileKey === fieldName) {
          console.log("jjj", saveFileUploadData.data.preview.preview_key);
          updatedPersonalDetails.fields[i].preview.preview_key =
            saveFileUploadData.data.preview.preview_key;
        }
        if (
          fieldName === "parental_consent_file" &&
          uploadedFileKey === fieldName
        ) {
          updatedPersonalDetails.fields[i].preview.preview_key =
            saveFileUploadData.data[0].preview_key;
        }
      }

      for (var i in updatedPersonalDetails.fields) {
        const fieldName = updatedPersonalDetails.fields[i].field_name;

        if (
          fieldName === "covid_vaccine_file" &&
          uploadedFileKey === fieldName
        ) {
          updatedPersonalDetails.fields[i].preview.preview_key =
            saveFileUploadData?.data.preview?.preview_key;

          if (Object.keys(personalDetails).length > 0) {
            Object.values(personalDetails.fields).map((item, index) => {
              if (item.field_name === "covid_vaccine_file") {
                Object.values(updatedPersonalDetails.fields).map((it) => {
                  if (it.field_name === "covid_vaccine_file") {
                    it.preview = item.preview;
                  }
                });
              }
            });
          }
        }

        if (
          fieldName === "form_16_file" &&
          uploadedFileKey === fieldName
        ) {
          updatedPersonalDetails.fields[i].preview.preview_key =
            saveFileUploadData?.data.preview?.preview_key;

          if (Object.keys(personalDetails).length > 0) {
            Object.values(personalDetails.fields).map((item, index) => {
              if (item.field_name === "form_16_file") {
                Object.values(updatedPersonalDetails.fields).map((it) => {
                  if (it.field_name === "form_16_file") {
                    it.preview = item.preview;
                  }
                });
              }
            });
          }
        }
      }
      if(updatedPersonalDetails?.other_checks){
        for(let otherCheckId in updatedPersonalDetails?.other_checks) {
          let otherCheck = updatedPersonalDetails?.other_checks[otherCheckId]
          if(otherCheck?.docs?.length) {
            console.log("reached here....", otherCheck?.docs)
            const indexDocToUpdate = otherCheck?.docs?.findIndex(checkDoc => checkDoc?.field_name == uploadedFileKey);
            console.log("reached here 2...",indexDocToUpdate,uploadedFileKey) 
            if(indexDocToUpdate > -1){
              updatedPersonalDetails.other_checks[otherCheckId].docs[indexDocToUpdate].preview = saveFileUploadData?.data[0]
            }
          }
          
        }
      }
      setPersonalDetails(updatedPersonalDetails);
    }
  }, [saveFileUploadData, storeData3]);

  const refresh = () => {
    // const flexFields = (profileFieldsData?.data?.allFlexFields || [])
    console.log("abcs", inputFormData);
    const flexFields = (profileFieldsData?.data?.allFlexFields || []).map(
      (data) => {
        if (data.input_type == 3) {
          return {
            ...data,
            input_type: 4,

            isflexField: true,
          };
        }
        if (data.input_type == 4) {
          return {
            ...data,
            input_type: 7,

            isflexField: true,
          };
        }
        return { ...data, isflexField: true };
      }
    );
    //formData = {};
    let obj1 = {};
    (profileFieldsData?.data?.allFlexFields || []).map((data) => {
      if (data.input_type == 3 && data.field_name !== "bridge_location_id") {
        // if(data?.checkData==""){
        //   data.checkData=inputFormData[`${data.field_id}`];
        // }
        return (obj1[`${data.field_id}`] = {
          value: data?.checkData,
          label: data.checkData,
        });
      } else if (data.field_name === "bridge_location_id") {
        let labelVal = "";
        for (let i = 0; i < bridgeLocation.length; i++) {
          if (bridgeLocation[i].value == data?.checkData) {
            labelVal = bridgeLocation[i].label;
          }
        }
        console.log(labelVal);
        // if(data?.checkData==""){
        //   data.checkData=inputFormData[`${data.field_name}`];
        // }
        return (obj1[`${data.field_name}`] = {
          value: data?.checkData,
          label: labelVal,
        });
      } else if (data.field_name == "cc_email_address") {
        // if(data?.checkData==""){
        //   data.checkData=inputFormData[`${data.field_name}`];
        // }
        return (obj1[`${data.field_name}`] = data?.checkData);
      } else {
        // if(data?.checkData==""){
        //   data.checkData=inputFormData[`${data.field_id}`];
        // }
        return (obj1[`${data.field_id}`] = data?.checkData);
      }
    });

    let additionalFieldObj={};
    let userVerif=JSON.parse(localStorage.getItem("userVerificationCandidate"));
    if(userVerif?.client_id == "424889"){
      flexFields.forEach((data)=>{
      if(data?.field_name == "bridge_location_id"){
        let dropValue = getDropdownOption(data);
         obj1[data?.field_name]=dropValue[0];
      }
    });
  }
    console.log(obj1);
    setInputFields([...flexFields]);
    setInputFormData({});
    setInputFormData(obj1);
  };

  console.log("xyz", inputFormData);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getProfileFields());
    };

    fetchData();
  }, []);

  const getDropdownOption = (inputObj) => {
    if (inputObj.field_name == "mobile_code") {
      return countryCodeOptions?.map((data) => {
        return {
          value: data.value,
          label: `${data.label.text}`,
        };
      });
    }

    if (inputObj.field_name == "bridge_location_id") {
      return bridgeLocation.map((data) => {
        return {
          value: data.value,
          label: data.label,
        };
      });
    }

    if (inputObj.field_name == "cc_email_address") {
      return !inputObj.options
        ? []
        : inputObj.options.map((data) => {
            return {
              value: data,
              label: data,
            };
          });
    }

    if (inputObj.optionArray) {
      if (inputObj.optionArray.options) {
        return Object.keys(inputObj.optionArray.options).map((key) => {
          return { value: inputObj.optionArray.options[key], label: key };
        });
      }
      return [];
    }
    return [];
  };

  const createIsFileUploadedObject = (data) => {
    const obj = {};
    for (let i in data) {
      if (data[i].field_name === "marital_status") {
        const isApplicable = data[i].value === "Married" ? true : false;
        setDateOfMarriageApplicable(isApplicable);
      }
      if (data[i].input_type == 8) {
        obj[`${data[i].field_name}`] = false;
      }
    }

    setIsFileUploadedObject(obj);
  };

  const setPersonalDataForMapping = (data) => {
    const updatedDataFields = {};
    for (var i in data.fields) {
      if (
        !["mobile_code", "alternate_mobile_country_code"].includes(
          data.fields[i].field_name
        )
      ) {
        updatedDataFields[i] = data.fields[i];
      }
    }
    const mappingDataFields = mapAnArrayWithTwoDivisions(updatedDataFields);
    // const mappingCustomFields = mapAnArrayWithTwoDivisions(data.custom_fields);
    let data1 = transformInput(mappingDataFields);
    setMappingArray(data1);
    // setCustomMappingArray(mappingCustomFields);
  };

  const transformInput = (input) => {
    // Flatten the input array
    const flattened = input.flat();
  
    const result = [];
    let index = 0;
  
    // Add first 2 elements to the first subarray
    result.push(flattened.slice(index, index + 2));
    index += 2;
  
    // Add next 3 elements to the second subarray
    result.push(flattened.slice(index, index + 3));
    index += 3;
  
    // Add remaining elements in subarrays of 2 elements each
    while (index < flattened.length) {
      result.push(flattened.slice(index, index + 2));
      index += 2;
    }
  
    return result;
  };



  const mapAnArrayWithTwoDivisions = (data) => {
    const mappingData = Object.keys(data).reduce(function (rows, key, index) {
      return (
        (index % 2 == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) &&
        rows
      );
    }, []);

    return mappingData;
  };
  const createErrorData = (personalDetails) => {
    const errorData = {};
    for (var i in personalDetails.fields) {
      errorData[`${personalDetails.fields[i].field_name}`] = false;
    }
    for (var i in personalDetails.custom_fields) {
      errorData[`${personalDetails.custom_fields[i].slug}`] = false;
      if (i === "consent") {
        if (personalDetails.custom_fields[i].value == "1") {
          setConsentIsChecked(true);
        } else {
          setConsentIsChecked(false);
        }
      }
    }
    setErrorData(errorData);
  };
  const form = useRef();

  const updatedGenderDataCallback = (data) => {
    if(data?.gender) {
      setUpdatedGenderData(data?.gender);
    }
  }

  const handleInputChange = (e, isMandat, fieldFrom = "", otherCheckId = "") => {
    if (e.target.name === "marital_status") {
      const isApplicable = e.target.value === "Married" ? true : false;
      setDateOfMarriageApplicable(isApplicable);
    }
    if (e?.target?.name === "prefix") {
      //api call 
      dispatch(getGenderListonPrefix({ option: e?.target?.value || "" }, updatedGenderDataCallback))
      // resetting the value of gender 
      const genderfield = Object.entries(personalDetails?.fields || {})?.find(field => field[1] && field[1]?.field_name === "gender");

      if (genderfield?.length) {
        const genderId = genderfield[0]
        setPersonalDetails((prevState) => ({
          ...prevState,
          fields: {
            ...prevState.fields,
            [genderId]: {
              ...prevState.fields[genderId],
              value: "",
            },
          },
        }));
      }
    }
    switch (e.target.name) {
      case "mobile_no":
      case "alternate_mobile_no":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: userLocalData?.client_id == "411448" ? !validateMobileNumber10Digits(e.target.value) : !validateMobileNumber711(e.target.value),
        }));
        break;
      case "email_address":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validateEmail(e.target.value),
        }));
        break;
      case "first_name":
      case "middle_name":
      case "last_name":
      case "father_name":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validateAlphabetsAndSpace(e.target.value),
        }));
        break;
      case "prefix":
      case "gender":
      case "marital_status":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value === "" ? true : false,
        }));
        break;
      case "pan_number":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validatePAN(e.target.value)
        }));
        break;
      case "uan_number":
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: !validateUAN(e.target.value)
        }));
        break;
      default:
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: false,
        }));
    }

    if (
      e.target.name === "alternate_mobile_no" ||
      e.target.name === "mobile_no"
    ) {
      const fields = _.cloneDeep(personalDetails.fields);
      let mobileNumber = "";
      const dependentField =
        e.target.name === "alternate_mobile_no"
          ? "mobile_no"
          : "alternate_mobile_no";

      let currentFieldNumberCode = "";
      let dependentFieldCode = "";
      for (var i in fields) {
        if (fields[i].field_name == dependentField) {
          mobileNumber = fields[i].value;
        }
        if (dependentField === "alternate_mobile_no") {
          if (fields[i].field_name == "alternate_mobile_country_code") {
            dependentFieldCode = fields[i].value;
          }
          if (fields[i].field_name == "mobile_code") {
            currentFieldNumberCode = fields[i].value;
          }
        } else if (dependentField === "mobile_no") {
          if (fields[i].field_name == "mobile_code") {
            dependentFieldCode = fields[i].value;
          }
          if (fields[i].field_name == "alternate_mobile_country_code") {
            currentFieldNumberCode = fields[i].value;
          }
        }
      }
      let isValid = userLocalData?.client_id == "411448" ? validateMobileNumber10Digits(e.target.value) : validateMobileNumber711(e.target.value);

      if(e.target.value == "" && isMandat == 0){
        isValid=true;
      }
      if (isValid) {
        const mobileNumberWithCode = mobileNumber + dependentFieldCode;
        const currentFieldNumberWithCode =
          e.target.value + currentFieldNumberCode;
        if (
          mobileNumber !== "" &&
          currentFieldNumberWithCode === mobileNumberWithCode
        ) {
          setErrorData((prevState) => ({
            ...prevState,
            [e.target.name]: true,
          }));
        } else {
          setErrorData((prevState) => ({
            ...prevState,
            [e.target.name]: false,
            [dependentField]: mobileNumber
              ? userLocalData?.client_id == "411448" ? !validateMobileNumber10Digits(mobileNumber) : !validateMobileNumber711(mobileNumber)
              : false,
          }));
        }
      } else {
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: true,
        }));
      }
    }

    // if (e.target.name === "mobile_no") {
    //   const fields = _.cloneDeep(personalDetails.fields);
    //   let altMobileNumber = "";
    //   for (var i in fields) {
    //     if (fields[i].field_name == "alternate_mobile_no") {
    //       altMobileNumber = fields[i].value;
    //     }
    //   }
    //   if (altMobileNumber !== "" && e.target.value === altMobileNumber) {
    //     setErrorData((prevState) => ({
    //       ...prevState,
    //       [e.target.name]: true,
    //     }));
    //   }
    // }
    if(fieldFrom === "other_check_doc") {
      setPersonalDetails((prevState) => ({
        ...prevState,
        other_checks : {
          ...prevState.other_checks,
          [otherCheckId] : {
            docs : {...prevState.other_checks[otherCheckId].docs,
              [e.target.id] : {
                ...prevState.other_checks[otherCheckId].docs[e.target.id],
                value: e.target.value
              }
            },
            fields: {...prevState.other_checks[otherCheckId].fields}
          }
        }
      }))
    } else if(fieldFrom === "other_check") {
      setPersonalDetails((prevState) => ({
        ...prevState,
        other_checks : {
          ...prevState.other_checks,
          [otherCheckId] : {
            docs : {...prevState.other_checks[otherCheckId].docs},
            fields: {...prevState.other_checks[otherCheckId].fields,
              [e.target.id] : {
                ...prevState.other_checks[otherCheckId].fields[e.target.id],
                value: e.target.value
              }
            }
          }
        }
      }))
    }
    else if (e.target.dataset.title == "field") {
      setPersonalDetails((prevState) => ({
        ...prevState,
        fields: {
          ...prevState.fields,
          [e.target.id]: {
            ...prevState.fields[e.target.id],
            value: e.target.value,
          },
        },
      }));
    } else {
      setPersonalDetails((prevState) => ({
        ...prevState,
        custom_fields: {
          ...prevState.custom_fields,
          [e.target.id]: {
            ...prevState.custom_fields[e.target.id],
            value: e.target.value,
          },
        },
      }));
    }
  };

  const saveDate = (id, val) => {
    if (val == "Invalid date") {
      val = "";
      const errorField = personalDetails.fields[id].field_name;
      let newErr = _.cloneDeep(errorData);
      newErr[errorField] = true;
      setErrorData(newErr);
    } else {
      const errorField = personalDetails.fields[id].field_name;
      let newErr = _.cloneDeep(errorData);
      newErr[errorField] = false;
      setErrorData(newErr);
      localStorage.setItem("dob", val);
    }

    setPersonalDetails((prevState) => ({
      ...prevState,
      fields: {
        ...prevState.fields,
        [id]: {
          ...prevState.fields[id],
          value: val,
        },
      },
    }));
  };

  const checkBeforeSave1 = async (e) => {
    // e.preventDefault();
    // let record1={};
    // record1.reference_number=referenceNumber;
    // dispatch(getVerifyCompleted(record1));

    // const data=await dispatch(getProfileFields());
    //console.log("update",data);
    if (verify == false) {
      checkBeforeSave(true);
      return false;
    }

    if (verify == true) {
      let hasError = false;
      //  setErrorData({});

      for (let i in personalDetails.fields) {
        if (
          personalDetails.fields[i].is_mandatory === 1 &&
          (personalDetails.fields[i].value === "" ||
            personalDetails.fields[i].value === null)
        ) {
          if (
            personalDetails.fields[i].field_name === "parental_consent_file" &&
            !minorCandidate
          ) {
            continue;
          }
          if (
            personalDetails.fields[i].field_name === "parental_consent_file" &&
            minorCandidate
          ) {
            continue;
            if (
              personalDetails.fields[i].preview &&
              personalDetails.fields[i].preview.preview_key
            ) {
              continue;
            }
          }
          if (personalDetails.fields[i].field_name === "cv_document_file") {
            continue;
            if (
              personalDetails.fields[i].preview &&
              personalDetails.fields[i].preview.preview_key
            ) {
              continue;
            }
          }
          if (
            personalDetails.fields[i].field_name === "date_of_marriage" &&
            !dateOfMarriageApplicable
          ) {
            continue;
          }
          // if (personalDetails.fields[i].field_name === "covid_vaccine_file") {
          //   if (
          //     personalDetails.fields[i].preview &&
          //     personalDetails.fields[i].preview.preview_key
          //   ) {
          //     continue;
          //   }
          // }
          // if (personalDetails.fields[i].field_name === "form_16_file") {
          //   if (
          //     personalDetails.fields[i].preview &&
          //     personalDetails.fields[i].preview.preview_key
          //   ) {
          //     continue;
          //   }
          // }
          //remove later
          if (
            ["candidate_photo", "fv_id_card_file"].includes(
              personalDetails.fields[i].field_name
            )
          ) {
            continue;
          }

          hasError = true;
          setErrorData((prevState) => ({
            ...prevState,
            [personalDetails.fields[i].field_name]: true,
          }));
        }
      }

      for (let i in personalDetails.fields) {
        if (
          personalDetails.fields[i].is_mandatory === 1 &&
          (personalDetails.fields[i].value === "" ||
            personalDetails.fields[i].value === null)
        ) {
          if (
            personalDetails.fields[i].field_name === "parental_consent_file" &&
            !minorCandidate
          ) {
            continue;
          }
          if (
            personalDetails.fields[i].field_name === "parental_consent_file" &&
            minorCandidate
          ) {
            if (epUploader["parental_consent_file"] !== undefined) {
              continue;
            }

            if (
              personalDetails.fields[i].preview &&
              personalDetails.fields[i].preview.preview_key
            ) {
              continue;
            }
          }
          if (personalDetails.fields[i].field_name === "cv_document_file") {
            if (epUploader["cv_document_file"] !== undefined) {
              continue;
            }
            if (
              personalDetails.fields[i].preview &&
              personalDetails.fields[i].preview.preview_key
            ) {
              continue;
            }
          }
          if (personalDetails.fields[i].field_name === "covid_vaccine_file") {
            if (epUploader["covid_vaccine_file"] !== undefined) {
              continue;
            }
            if (
              personalDetails.fields[i].preview &&
              personalDetails.fields[i].preview.preview_key
            ) {
              continue;
            }
          }
          if (personalDetails.fields[i].field_name === "form_16_file") {
            if (epUploader["form_16_file"] !== undefined) {
              continue;
            }
            if (
              personalDetails.fields[i].preview &&
              personalDetails.fields[i].preview.preview_key
            ) {
              continue;
            }
          }
          if (
            personalDetails.fields[i].field_name === "date_of_marriage" &&
            !dateOfMarriageApplicable
          ) {
            continue;
          }
          //remove later
          if (
            ["candidate_photo", "fv_id_card_file"].includes(
              personalDetails.fields[i].field_name
            )
          ) {
            continue;
          }

          hasError = true;
          setErrorData((prevState) => ({
            ...prevState,
            [personalDetails.fields[i].field_name]: true,
          }));
        } else if (personalDetails?.fields[i].field_name === "uan_number" 
          && personalDetailsData?.data?.isUanVerified != 1 
          && profileFieldsData?.data?.isUanVerified != 1
          && uanVerificationData?.data?.api_hit_count != 3 
          && uanVerificationData?.data?.status != "success") {
          hasError = true;
          // setErrorData((prevState) => ({
          //   ...prevState,
          //   [personalDetails.fields[i].field_name]: true,
          // }));
          let errorMsg = "Please verify your UAN number and then proceed.";
          toast.error(errorMsg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }

      // for (let i in personalDetails.custom_fields) {
      //   if (
      //     personalDetails.custom_fields[i].is_mandatory == 1 &&
      //     (personalDetails.custom_fields[i].value == "" ||
      //       personalDetails.custom_fields[i].value == null)
      //   ) {
      //     hasError = true;
      //     setErrorData((prevState) => ({
      //       ...prevState,
      //       [personalDetails.custom_fields[i].slug]: true,
      //     }));
      //   }
      // }

      for (let i in inputFields) {
        if (
          inputFields[i].is_mandatory === 1 &&
          (inputFields[i].checkData === "" || inputFields[i].checkData === null)
        ) {
          hasError = true;
          setErrorData((prevState) => ({
            ...prevState,
            [inputFields[i].field_name]: true,
          }));
        } else {
          const check = inputFields[i].field_name;

          setErrorData((prevState) => ({
            ...prevState,
            [inputFields[i].field_name]: false,
          }));
          console.log(errorData);
        }
      }
      for (let otherCheckId in personalDetails.other_checks) {
        if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.fields){
          for(let fieldIndex in personalDetails.other_checks[otherCheckId]?.fields) {
            if(personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].is_mandatory == 1 &&
              (personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value == "" ||
                personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value == null)) {
                  hasError = true;
                  setErrorData((prevState) => ({
                    ...prevState,
                    [personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].field_name]: true,
                  }));
                }
          }
        }
        if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.docs){
          for(let docIndex in personalDetails.other_checks[otherCheckId]?.docs) {
            if(personalDetails.other_checks[otherCheckId]?.docs[docIndex].is_mandatory == 1 &&
              !(epUploader[personalDetails.other_checks[otherCheckId]?.docs[docIndex].field_name]) && !(personalDetails.other_checks[otherCheckId]?.docs[docIndex].preview)) {
                hasError = true;
              setErrorData((prevState) => ({
                ...prevState,
                [personalDetails.other_checks[otherCheckId]?.docs[docIndex].field_name]: true,
              }));
              }
            // else if(personalDetails.other_checks[otherCheckId]?.docs[docIndex].is_mandatory == 1 &&
            //   !(personalDetails.other_checks[otherCheckId]?.docs[docIndex].preview)) {
            //       hasError = true;
            //       setErrorData((prevState) => ({
            //         ...prevState,
            //         [personalDetails.other_checks[otherCheckId]?.docs[docIndex].field_name]: true,
            //       }));
            //     }
          }
        }
      }
      // Uncommented this code for IB-11333
      for (let i in errorData) {
        if (errorData[i] === true) {
          hasError = true;
          break;
        }
      }
      //
      if (hasError) {
        // setIsLoading(false);
        return;
      }
      const formData = getFormData();
      console.log("hg", formData);

      let isError = false;
      // formData.CaseFlexFieldData = {};

      const inputFieldArray = inputFields.map((data) => {
        if (!data.isflexField) {
          formData[data.field_name] =
            typeof inputFormData[data.field_name] == "object"
              ? inputFormData[data.field_name].value
              : inputFormData[data.field_name] || "";
        } else {
          // formData.CaseFlexFieldData[data.field_id] =
          //   typeof inputFormData[data.field_name] == "object"
          //     ? inputFormData[data.field_name].value
          //     : inputFormData[data.field_name] || "";
        }

        if (inputFormData[data.field_name]) {
          if (data.field_name == "email_address") {
            if (!validateEmail(inputFormData[data.field_name])) {
              isError = true;
              return { ...data, error: "Please Enter valid email" };
            }
          }
          if (data.field_name == "cc_email_address") {
            setErrorData((prevState) => ({
              ...prevState,
              [data.field_name]: false,
            }));
            if (!validateEmail(inputFormData[data.field_name])) {
              isError = true;
              setErrorData((prevState) => ({
                ...prevState,
                [data.field_name]: true,
              }));
              return { ...data, error: "Please Enter valid email" };
            }
          }

          if (data.field_name == "date_of_birth") {
            const [day] = differenceInTime("", inputFormData[data.field_name]);
            if (Math.abs(day) / 365 < 14) {
              isError = true;
              return {
                ...data,
                error: "Please Enter valid date greater then 14 year",
              };
            }
          }

          if (data.field_name == "mobile_no") {
            if (!validateMobileNumber(inputFormData[data.field_name])) {
              isError = true;
              return { ...data, error: "Please Enter valid mobile number" };
            }
          }
        }
        return { ...data, error: "" };
      });

      console.log("hg", isError);

      if (isError) {
        setInputFields(inputFieldArray);
      } else {
        setInputFields(inputFieldArray);

        console.log("mkkk", formData);

        // formData.up = epUploader;

        console.log(errorData);
        delete formData?.candidateData?.CaseFlexFieldData?.cc_email_address;
      }
    }

    // if(data?.data?.isEmailVerified == 0){
    if (
      verifyEmailData.status != "success" &&
      profileFieldsData.data?.isEmailVerified != 1
    ) {
      let errorMsg = "Please verify your Email Account first  and then proceed";
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    let record = {};
    record.reference_number = referenceNumber;
    console.log(profileFieldsData.data?.showProfilePreview);
    dispatch(getVerifyCompleted(record,profileFieldsData.data?.showProfilePreview));
  };

  const checkBeforeSave = (val) => {
    if (val == false) {
      let errorMsg = "Please verify your Email Account first and then proceed.";
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    }
    if (
      personalDetails.isCreditConfirmation &&
      personalDetails.isCreditConfirmation == 1
    ) {
      setShowConfirmationPopup(true);
      const isIndianMobile =
        personalDetails.fields[8] && personalDetails.fields[8].value == 91
          ? true
          : false;
      if (isIndianMobile) {
        setPopupMsg(
          "This information will be used to validate your credit history and other checks, kindly ensure that the information provided by you is accurate. You will NOT be able to modify these details later. Do you wish to proceed?"
        );
      } else {
        setPopupMsg(
          "Kindly provide an active Indian mobile number registered with your bank and credit cards on which you are receiving SMS and is currently accessible to you. Do you wish to proceed?"
        );
      }
    } else {
      saveProfileDetails();
    }
  };

  const saveProfileDetails = async (record) => {
    // setIsLoading(true);
    let hasError = false;
    //  setErrorData({});

    for (let i in personalDetails.fields) {
      if (
        personalDetails.fields[i].is_mandatory === 1 &&
        (personalDetails.fields[i].value === "" ||
          personalDetails.fields[i].value === null)
      ) {
        if (
          personalDetails.fields[i].field_name === "parental_consent_file" &&
          !minorCandidate
        ) {
          continue;
        }
        if (
          personalDetails.fields[i].field_name === "parental_consent_file" &&
          minorCandidate
        ) {
          continue;
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "cv_document_file") {
          continue;
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (
          personalDetails.fields[i].field_name === "date_of_marriage" &&
          !dateOfMarriageApplicable
        ) {
          continue;
        }
        if (personalDetails.fields[i].field_name === "covid_vaccine_file") {
          continue;
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "form_16_file") {
          continue;
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        //remove later
        if (
          ["candidate_photo", "fv_id_card_file"].includes(
            personalDetails.fields[i].field_name
          )
        ) {
          continue;
        }

        hasError = true;
        if(personalDetails.fields[i].field_name)
        setErrorData((prevState) => ({
          ...prevState,
          [personalDetails.fields[i].field_name]: true,
        }));
      }
    }

    for (let i in personalDetails.fields) {
      if (
        personalDetails.fields[i].is_mandatory === 1 &&
        (personalDetails.fields[i].value === "" ||
          personalDetails.fields[i].value === null)
      ) {
        if (
          personalDetails.fields[i].field_name === "parental_consent_file" &&
          !minorCandidate
        ) {
          continue;
        }
        if (
          personalDetails.fields[i].field_name === "parental_consent_file" &&
          minorCandidate
        ) {
          if (epUploader["parental_consent_file"] !== undefined) {
            continue;
          }

          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "cv_document_file") {
          if (epUploader["cv_document_file"] !== undefined) {
            continue;
          }
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "covid_vaccine_file") {
          if (epUploader["covid_vaccine_file"] !== undefined) {
            continue;
          }
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (personalDetails.fields[i].field_name === "form_16_file") {
          if (epUploader["form_16_file"] !== undefined) {
            continue;
          }
          if (
            personalDetails.fields[i].preview &&
            personalDetails.fields[i].preview.preview_key
          ) {
            continue;
          }
        }
        if (
          personalDetails.fields[i].field_name === "date_of_marriage" &&
          !dateOfMarriageApplicable
        ) {
          continue;
        }
        //remove later
        if (
          ["candidate_photo", "fv_id_card_file"].includes(
            personalDetails.fields[i].field_name
          )
        ) {
          continue;
        }

        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [personalDetails.fields[i].field_name]: true,
        }));
      } else if (personalDetails?.fields[i].field_name === "uan_number" 
                && personalDetailsData?.data?.isUanVerified != 1 
                && profileFieldsData?.data?.isUanVerified != 1
                && uanVerificationData?.data?.api_hit_count != 3 
                && uanVerificationData?.data?.status != "success") {
              hasError = true;
              // setErrorData((prevState) => ({
              //   ...prevState,
              //   [personalDetails.fields[i].field_name]: true,
              // }));
              let errorMsg = "Please verify your UAN number and then proceed.";
              toast.error(errorMsg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
    }

    // for (let i in personalDetails.custom_fields) {
    //   if (
    //     personalDetails.custom_fields[i].is_mandatory == 1 &&
    //     (personalDetails.custom_fields[i].value == "" ||
    //       personalDetails.custom_fields[i].value == null)
    //   ) {
    //     hasError = true;
    //     setErrorData((prevState) => ({
    //       ...prevState,
    //       [personalDetails.custom_fields[i].slug]: true,
    //     }));
    //   }
    // }

    for (let i in inputFields) {
      if (
        inputFields[i].is_mandatory === 1 &&
        (inputFields[i].checkData === "" || inputFields[i].checkData === null)
      ) {
        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [inputFields[i].field_name]: true,
        }));
      } else {
        const check = inputFields[i].field_name;

        setErrorData((prevState) => ({
          ...prevState,
          [inputFields[i].field_name]: false,
        }));
        console.log(errorData);
      }
    }
    for (let otherCheckId in personalDetails.other_checks) {
      if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.fields){
        for(let fieldIndex in personalDetails.other_checks[otherCheckId]?.fields) {
          if(personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].is_mandatory == 1 &&
            (personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value == "" ||
              personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value == null)) {
                hasError = true;
                setErrorData((prevState) => ({
                  ...prevState,
                  [personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].field_name]: true,
                }));
              }
        }
      }
      if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.docs){
        for(let docIndex in personalDetails.other_checks[otherCheckId]?.docs) {
          if(personalDetails.other_checks[otherCheckId]?.docs[docIndex].is_mandatory == 1 &&
            !(epUploader[personalDetails.other_checks[otherCheckId]?.docs[docIndex].field_name]) && !(personalDetails.other_checks[otherCheckId]?.docs[docIndex].preview)) {
              hasError = true;
            setErrorData((prevState) => ({
              ...prevState,
              [personalDetails.other_checks[otherCheckId]?.docs[docIndex].field_name]: true,
            }));
            }
          // else if(personalDetails.other_checks[otherCheckId]?.docs[docIndex].is_mandatory == 1 &&
          //   !(personalDetails.other_checks[otherCheckId]?.docs[docIndex].preview)) {
          //       hasError = true;
          //       setErrorData((prevState) => ({
          //         ...prevState,
          //         [personalDetails.other_checks[otherCheckId]?.docs[docIndex].field_name]: true,
          //       }));
          //     }
        }
      }
    }
    // Uncommented this code for IB-11333
    for (let i in errorData) {
      if (errorData[i] === true) {
        hasError = true;
        break;
      }
    }
    //
    if (hasError) {
      // setIsLoading(false);
      let errorMsg="Please fill all the mandatory fields.";
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });    
      return;
    }
    const formData = getFormData();
    console.log("hg", formData);

    let isError = false;
    // formData.CaseFlexFieldData = {};

    const inputFieldArray = inputFields.map((data) => {
      if (!data.isflexField) {
        formData[data.field_name] =
          typeof inputFormData[data.field_name] == "object"
            ? inputFormData[data.field_name].value
            : inputFormData[data.field_name] || "";
      } else {
        // formData.CaseFlexFieldData[data.field_id] =
        //   typeof inputFormData[data.field_name] == "object"
        //     ? inputFormData[data.field_name].value
        //     : inputFormData[data.field_name] || "";
      }

      if (inputFormData[data.field_name]) {
        if (data.field_name == "email_address") {
          if (!validateEmail(inputFormData[data.field_name])) {
            isError = true;
            return { ...data, error: "Please Enter valid email" };
          }
        }
        if (data.field_name == "cc_email_address") {
          setErrorData((prevState) => ({
            ...prevState,
            [data.field_name]: false,
          }));
          if (!validateEmail(inputFormData[data.field_name])) {
            isError = true;
            setErrorData((prevState) => ({
              ...prevState,
              [data.field_name]: true,
            }));
            return { ...data, error: "Please Enter valid email" };
          }
        }

        if (data.field_name == "date_of_birth") {
          const [day] = differenceInTime("", inputFormData[data.field_name]);
          if (Math.abs(day) / 365 < 14) {
            isError = true;
            return {
              ...data,
              error: "Please Enter valid date greater then 14 year",
            };
          }
        }

        if (data.field_name == "mobile_no") {
          if (!validateMobileNumber(inputFormData[data.field_name])) {
            isError = true;
            return { ...data, error: "Please Enter valid mobile number" };
          }
        }
      }
      return { ...data, error: "" };
    });

    console.log("hg", isError);

    if (isError) {
      setInputFields(inputFieldArray);
    } else {
      setInputFields(inputFieldArray);

      console.log("mkkk", formData);

      // formData.up = epUploader;

      console.log(errorData);
      delete formData?.candidateData?.CaseFlexFieldData?.cc_email_address;
      if (record == "ignore") {
        dispatch(
          getSavePersonalDetailByclient(
            formData,
            referenceNumber,
            1,
            epUploader
          )
        );
        dispatch(deleteVerifyCompleted());
      } else {
        dispatch(
          getSavePersonalDetailByclient(
            formData,
            referenceNumber,
            personalComplete,
            epUploader
          )
        );
        dispatch(deleteVerifyCompleted());
      }
    }

    // navigate("/candidate-form/national-id");
  };

  const getFormData = () => {
    const formData = {};
    const customFieldsData = {};
    const additionalFieldPayload = _.cloneDeep(inputFormData);

    for (var i in personalDetails.fields) {
      formData[`${personalDetails.fields[i].field_name}`] =
        personalDetails.fields[i].value;
    }
    for (var i in personalDetails.custom_fields) {
      if (personalDetails.custom_fields[i].value.length > 0) {
        customFieldsData[`${personalDetails.custom_fields[i].slug}`] =
          personalDetails.custom_fields[i].value;
      }
    }
    for(let otherCheckId in personalDetails.other_checks){
      if(personalDetails.other_checks[otherCheckId] && personalDetails.other_checks[otherCheckId]?.fields){
        for(let fieldIndex in personalDetails.other_checks[otherCheckId]?.fields) {
          let otherCheckFieldName = personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].field_name;
          let otherCheckFieldValue = personalDetails.other_checks[otherCheckId]?.fields[fieldIndex].value;
          formData[otherCheckFieldName] = otherCheckFieldValue
        }
      }
    }
    formData["customfields_data"] = customFieldsData;
    // formData["uploader"] = epUploader;
    formData["id"] = Id;
    // for (var i in inputFields) {

    //   formData[`${inputFields[i].field_name}`] =
    //   inputFields[i].checkData;
    // }
    let isError = false;
    let obj = {};

    formData.bridge_location_id =
      additionalFieldPayload?.bridge_location_id?.value;
    formData.cc_email_address = additionalFieldPayload.cc_email_address;
    obj.candidateData = { ...formData };
    delete additionalFieldPayload.bridge_location_id;
    //  delete inputFormData.cc_email_address;
    delete additionalFieldPayload?.undefined;

    //  if ( inputFormData["cc_email_address"] !== "") {
    //   if (!validateEmail(inputFormData.cc_email_address)) {
    //     isError = true;
    //     return {  error: "Please Enter valid email" };
    //   }
    // }
    for (const [key, value] of Object.entries(additionalFieldPayload)) {
      if (value?.label != null) {
        additionalFieldPayload[key] = value?.value;
      }
    }
    obj.candidateData.CaseFlexFieldData = { ...additionalFieldPayload };
    return obj;
  };

  const [epUploader, setEpUploader] = useState({});
  const [fileNameUploaded, setFileNameUploaded] = useState({});

  const handleOtherCheckFileUpload = async (fieldName, file) => {
    setUploadedFileKey(fieldName);
    await dispatch(uploadFileViaMultipart(fieldName, file));
    setErrorData((prevState) => ({
      ...prevState,
      [fieldName]: false,
    }));

    setIsFileUploadedObject((prevState) => ({
      ...prevState,
      [fieldName]: true,
    }));
      // setUnsavedData(personalDetails);
      // dispatch(getPersonalDetails());
  }

  const handleFileUpload = async (fieldName, file) => {
    // setIsLoading(true);
    setUploadedFileKey(fieldName);

    console.log("pp", file);

    //return false;
    // await dispatch(uploadFileViaMultipart(fieldName, file));

    if (role === "EP") {
      setEpUploader((prevState) => ({
        ...prevState,
        [fieldName]: file,
      }));

      //   var reader = new FileReader();

      //   reader.onload = function(e) {
      //   // binary data

      //   setEpUploader((prevState) => ({
      //     ...prevState,
      //     [fieldName]: e.target.result,
      //   }));
      //  // console.log("cck",e.target.result);
      // };
      // reader.onerror = function(e) {
      //   // error occurred
      //   console.log('Error : ' + e.type);
      // };
      // reader.readAsBinaryString(file);
    } else {
      await dispatch(uploadFileViaMultipart(fieldName, file));
    }

    setErrorData((prevState) => ({
      ...prevState,
      [fieldName]: false,
    }));

    setIsFileUploadedObject((prevState) => ({
      ...prevState,
      [fieldName]: true,
    }));
    // fetchUpdatedData();
  };

  const handleCountryCode = (e) => {
    let updatedPersonalDetailsFields = _.cloneDeep(personalDetails.fields);
    if (
      e.target.name === "alternate_mobile_no" ||
      e.target.name === "mobile_no"
    ) {
      const fields = _.cloneDeep(personalDetails.fields);
      let dependentMobileNumber = "";
      let dependentMobileCode = "";
      let currentMobileNumber = "";
      let currentMobileCode = e.target.value;

      const dependentField =
        e.target.name === "alternate_mobile_no"
          ? "mobile_no"
          : "alternate_mobile_no";

      for (var i in fields) {
        if (fields[i].field_name == dependentField) {
          dependentMobileNumber = fields[i].value;
        }
        if(fields[i].field_name == "alternate_mobile_country_code" || fields[i].field_name == "mobile_code") {
          dependentMobileCode = e?.target?.value;
          updatedPersonalDetailsFields[i].value = e.target.value;
        }
        if (dependentField === "alternate_mobile_no") {
          // if (fields[i].field_name == "alternate_mobile_country_code") {
          //   dependentMobileCode = fields[i].value;
          // }
          if (fields[i].field_name == "mobile_no") {
            currentMobileNumber = fields[i].value;
          }
        } else if (dependentField === "mobile_no") {
          // if (fields[i].field_name == "mobile_code") {
          //   dependentMobileCode = fields[i].value;
          // }
          if (fields[i].field_name == "alternate_mobile_no") {
            currentMobileNumber = fields[i].value;
          }
        }
      }

      const dependentMobileNumberWithCode =
        dependentMobileCode + dependentMobileNumber;
      const currentMobileNumberWithCode =
        currentMobileCode + currentMobileNumber;

      if (currentMobileNumberWithCode == dependentMobileNumberWithCode) {
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: true,
        }));
      } else {
        setErrorData((prevState) => ({
          ...prevState,
          [e.target.name]: currentMobileNumber ? userLocalData?.client_id == "411448" ? !validateMobileNumber10Digits(currentMobileNumber) : !validateMobileNumber711(currentMobileNumber) : false,
          [dependentField]: dependentMobileNumber ? userLocalData?.client_id == "411448" ? !validateMobileNumber10Digits(dependentMobileNumber) : !validateMobileNumber711(dependentMobileNumber) : false,
        }));
      }
    }

    // const index = e.target.name === "mobile_no" ? 8 : 10;
    // updatedPersonalDetailsFields[index].value = e.target.value;
    let updatedPersonalDetails = _.cloneDeep(personalDetails);
    updatedPersonalDetails.fields = _.cloneDeep(updatedPersonalDetailsFields);
    setPersonalDetails(updatedPersonalDetails);
  };

  const fetchUpdatedData = async () => {
    setUnsavedData(personalDetails);
    dispatch(getProfileFields());
  };

  const closeConfirmationPopup = () => {
    setShowConfirmationPopup(false);
  };

  const proceedConfirm = () => {
    setShowConfirmationPopup(false);
    saveProfileDetails();
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  const {
    genderOptions,
    prefixOptions,
    maritalOptions,
    birthCountryOptions,
    countryCodeOptions,
    bridgeLocation,
  } = GetMasterData();

  const optionsKey = {
    prefix: prefixOptions,
    gender: genderOptions,
    marital_status: maritalOptions,
    birth_country: birthCountryOptions,
    mobile_no: countryCodeOptions,
    alternate_mobile_no: countryCodeOptions,
  };

  const handleRadioChange = (radioValues) => {
    const { dataset, value } = radioValues;
    setPersonalDetails((prevState) => ({
      ...prevState,
      custom_fields: {
        ...prevState.custom_fields,
        [dataset.fieldname]: {
          ...prevState.custom_fields[dataset.fieldname],
          value: value,
        },
      },
    }));
    setErrorData((prevState) => ({
      ...prevState,
      [dataset.fieldname]: false,
    }));
  };

  const handleCheckboxChange = (checkboxValues) => {
    const { dataset } = checkboxValues;
    const checkVal = consentIsChecked ? "" : "1";
    setConsentIsChecked(!consentIsChecked);
    setPersonalDetails((prevState) => ({
      ...prevState,
      custom_fields: {
        ...prevState.custom_fields,
        [dataset.fieldname]: {
          ...prevState.custom_fields[dataset.fieldname],
          value: checkVal,
        },
      },
    }));
    setErrorData((prevState) => ({
      ...prevState,
      [dataset.fieldname]: false,
    }));
  };

  const handleImageModal = (e, imagePreview) => {
    e.preventDefault();
    setModalImage(imagePreview);
    setShowImageModal(!showImageModal);
  };

  const closePopup = () => {
    setModalImage("");
    setShowImageModal(false);
  };

  const closeSubmitPopup = () => {
    setShowSubmitPopup(false);
  };

  const proceedSubmit = (e) => {
    setShowSubmitPopup(false);
    checkBeforeSave1(e);
  };

  const SubmitPopup = (e) => {
    e.preventDefault()
    setShowSubmitPopup(true);
  }


  // const handleDelete = async (e, docside) => {
  //   e.preventDefault();
  //   const recordArray = {};
  //   recordArray.doc_chk = eAadhaarData.checksDetails[0].case_check_id;
  //   recordArray.doc_ids =
  //     eAadhaarData.checksDetails[0].required_documents[0].id;
  //   recordArray.doc_ref = "all";
  //   recordArray.doc_side = docside;
  //   removeFile("check_documents", recordArray, aadhaarData);
  // };

  console.log(errorData, "fff");

  // useEffect(() => {
  //   inputFields &&
  //             inputFields.map((data,i) => {
  //               console.log(`${data.field_name}...${JSON.stringify(inputFormData[data.field_id])}`)
  //             })
  // })

  console.log("fee", isDuplicateModal);
  return (
    <>
      {isLoading && <Loader />}
      {showImageModal && (
        <ImagePopup
          showModalBox={1}
          title={"Uploaded file"}
          description={"..."}
          isAdd={true}
          image={modalImage}
          closePopup={closePopup}
        />
      )}
      <NotificationPanels />
      {role === "EP" ? <ClientHeader /> : ""}
      {role === "EP" ? <ClientSideBar /> : <Sidebar />}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        {/* {isLoading && <Loader />} */}
        {showConfirmationPopup && (
          <ConfirmationPopup
            showModalBox={1}
            closePopup={closeConfirmationPopup}
            title="Credit history"
            description={popupMsg}
            proceedHandler={proceedConfirm}
            // isAdd={false}
            // checkStatus={catchIfAnyStatusIsNotCompleted}
          />
        )}

        {showSubmitPopup && (
          <ConfirmationPopup
            showModalBox={1}
            closePopup={closeSubmitPopup}
            // title="Please make sure all the details are correct."
            description={"Please make sure all the details are correct before proceeding."}
            proceedHandler={proceedSubmit}
            // isAdd={false}
            // checkStatus={catchIfAnyStatusIsNotCompleted}
          />
        )}


        {Object.keys(personalDetails).length > 0 && (
          <div className="container-fluid">
            <div className="row">
              <div className="col-auto w-100-mbl bg-gray-mbl">
               <ProgressHeading/>
                {personalComplete == 1 && authComplete == 1 ? (
                  <CandidateTab activeTab={"personal"} />
                ) : (
                  <CandidateTabClient activeTab={"Personal Details"} />
                )}
              </div>
              <div className="col bg-gray-mbl">
                {/*Form*/}
                <form ref={form} className="p-3 form2 form-section">
                  <StepCount activeTab={"personal"} />
                  <h2 className="fnt-smi-bld">Personal Details</h2>
                  <p className="text-muted">Enter your personal details</p>
                  <hr />
                  {mappingArray.map((mappingArr) => {
                    return (
                      <div className="row">
                        {mappingArr.map((arr) => {
                          const fieldName =
                            personalDetails.fields[arr].field_name;
                          const countryCodeVal =
                            fieldName === "mobile_no"
                              ? personalDetails.fields[8].value
                              : fieldName === "alternate_mobile_no"
                              ? personalDetails.fields[10].value
                              : null;
                          const dateOfBirth = personalDetails.fields[7]
                            ? personalDetails.fields[7].value
                            : null;
                          return (
                            <>
                              {personalDetails.fields[arr].field_name ===
                              "parental_consent_file" ? (
                                minorCandidate ? (
                                  <div className="col-sm-4 col-md-12 col-xl-4">
                                    <div className="form-group">
                                      <InputField
                                        inputType={
                                          personalDetails.fields[arr].input_type
                                        }
                                        inputName={
                                          personalDetails.fields[arr].field_name
                                        }
                                        inputValue={
                                          personalDetails.fields[arr].value
                                        }
                                        errorField={
                                          personalDetails.fields[arr].field_name
                                        }
                                        uploadedFilePreview={
                                          personalDetails.fields[arr].preview &&
                                          personalDetails.fields[arr].preview
                                            .preview_key
                                            ? personalDetails.fields[arr]
                                                .preview.preview_key
                                            : "n.a."
                                        }
                                        isInputMandatory={
                                          personalDetails.fields[arr]
                                            .is_mandatory
                                        }
                                        inputLabel={
                                          personalDetails.fields[arr].label
                                        }
                                        parentalTemplateUrl={
                                          personalDetails.fields[arr]
                                            .parental_template_url
                                        }
                                        index={arr}
                                        handleOnChange={(e)=>handleInputChange(e, personalDetails.fields[arr].is_mandatory)}
                                        options={
                                          optionsKey[
                                            personalDetails.fields[arr]
                                              .field_name
                                          ]
                                            ? optionsKey[
                                                personalDetails.fields[arr]
                                                  .field_name
                                              ]
                                            : []
                                        }
                                        setMinorCandidate={(isMinor) =>
                                          setMinorCandidate(isMinor)
                                        }
                                        saveDate={saveDate}
                                        handleFileUpload={handleFileUpload}
                                        isFileUploadedObject={
                                          isFileUploadedObject
                                        }
                                        isField={true}
                                      />

                                      {errorData[
                                        personalDetails.fields[arr].field_name
                                      ] === true && (
                                        <p className="text-danger">
                                          Please upload parental consent
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  <></>
                                )
                              ) : personalDetails.fields[arr].field_name ===
                                "date_of_marriage" ? (
                                dateOfMarriageApplicable ? (
                                  <div className="col-sm-4 col-md-12 col-xl-4">
                                    <div className="form-group">
                                      <InputField
                                        inputType={
                                          personalDetails.fields[arr].input_type
                                        }
                                        inputName={
                                          personalDetails.fields[arr].field_name
                                        }
                                        inputValue={
                                          personalDetails.fields[arr].value
                                        }
                                        isInputMandatory={
                                          personalDetails.fields[arr]
                                            .is_mandatory
                                        }
                                        inputLabel={
                                          personalDetails.fields[arr].label
                                        }
                                        index={arr}
                                        handleOnChange={(e)=>handleInputChange(e, personalDetails.fields[arr].is_mandatory)}
                                        options={
                                          optionsKey[
                                            personalDetails.fields[arr]
                                              .field_name
                                          ]
                                            ? optionsKey[
                                                personalDetails.fields[arr]
                                                  .field_name
                                              ]
                                            : []
                                        }
                                        setMinorCandidate={(isMinor) =>
                                          setMinorCandidate(isMinor)
                                        }
                                        saveDate={saveDate}
                                        handleFileUpload={handleFileUpload}
                                        isFileUploadedObject={
                                          isFileUploadedObject
                                        }
                                        isField={true}
                                        dateOfBirth={dateOfBirth}
                                      />
                                      {errorData[
                                        personalDetails.fields[arr].field_name
                                      ] === true ? (
                                        personalDetails.fields[arr].value ===
                                          "" ||
                                        personalDetails.fields[arr].value ===
                                          null ? (
                                          <p className="text-danger">
                                            This is a required field.
                                          </p>
                                        ) : (
                                          <p className="text-danger">
                                            Please provide valid input
                                          </p>
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  <></>
                                )
                              ) : personalDetails.fields[arr].field_name ===
                                "cv_document_file" ? (
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        personalDetails.fields[arr].input_type
                                      }
                                      inputName={
                                        personalDetails.fields[arr].field_name
                                      }
                                      inputValue={
                                        personalDetails.fields[arr].value
                                      }
                                      errorField={"cv-doc-file"}
                                      uploadedFilePreview={
                                        personalDetails.fields[arr].preview &&
                                        personalDetails.fields[arr].preview
                                          .preview_key
                                          ? personalDetails.fields[arr].preview
                                              .preview_key
                                          : "n.a."
                                      }
                                      isInputMandatory={
                                        personalDetails.fields[arr].is_mandatory
                                      }
                                      inputLabel={
                                        personalDetails.fields[arr].label
                                      }
                                      index={arr}
                                      handleFileUpload={handleFileUpload}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                    />
                                    {errorData[
                                      personalDetails.fields[arr].field_name
                                    ] === true && (
                                      <p className="text-danger">
                                        Please upload CV file
                                      </p>
                                    )}
                                  </div>
                                </div>
                              ) : 
                              personalDetails.fields[arr].field_name ===
                                "covid_vaccine_file" ? (
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        personalDetails.fields[arr].input_type
                                      }
                                      inputName={
                                        personalDetails.fields[arr].field_name
                                      }
                                      inputValue={
                                        personalDetails.fields[arr].value
                                      }
                                      errorField={
                                        personalDetails.fields[arr].field_name
                                      }
                                      // errorField={"bs-doc-file"}
                                      uploadedFilePreview={
                                        personalDetails.fields[arr].preview &&
                                        personalDetails.fields[arr].preview
                                          .preview_key
                                          ? personalDetails.fields[arr].preview
                                              .preview_key
                                          : "n.a."
                                      }
                                      isInputMandatory={
                                        personalDetails.fields[arr].is_mandatory
                                      }
                                      inputLabel={
                                        personalDetails.fields[arr].label
                                      }
                                      index={arr}
                                      handleFileUpload={handleFileUpload}
                                      handleImageModal={handleImageModal}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                    />
                                    {personalDetails.fields[arr].field_name ===
                                    "covid_vaccine_file" ? (
                                      <small className="text-danger">
                                        Max upload limit - 5mb
                                        <br />
                                        Acceptable formats - pdf, png & jpeg are
                                        preferred
                                      </small>
                                    ) : (
                                      <></>
                                    )}
                                    {errorData[
                                      personalDetails.fields[arr].field_name
                                    ] === true && (
                                      <p className="text-danger">
                                        Please upload covid vaccine document.
                                      </p>
                                    )}
                                  </div>
                                </div>
                              ): 
                              personalDetails.fields[arr].field_name ===
                               "form_16_file" ? (
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        personalDetails.fields[arr].input_type
                                      }
                                      inputName={
                                        personalDetails.fields[arr].field_name
                                      }
                                      inputValue={
                                        personalDetails.fields[arr].value
                                      }
                                      errorField={
                                        personalDetails.fields[arr].field_name
                                      }
                                      // errorField={"bs-doc-file"}
                                      uploadedFilePreview={
                                        personalDetails.fields[arr].preview &&
                                        personalDetails.fields[arr].preview
                                          .preview_key
                                          ? personalDetails.fields[arr].preview
                                              .preview_key
                                          : "n.a."
                                      }
                                      isInputMandatory={
                                        personalDetails.fields[arr].is_mandatory
                                      }
                                      inputLabel={
                                        personalDetails.fields[arr].label
                                      }
                                      index={arr}
                                      handleFileUpload={handleFileUpload}
                                      handleImageModal={handleImageModal}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                    />
                                    {personalDetails.fields[arr].field_name ===
                                    "form_16_file" ? (
                                      <small className="text-danger">
                                        Max upload limit - 5mb
                                        <br />
                                        Acceptable formats - pdf, png & jpeg are
                                        preferred
                                      </small>
                                    ) : (
                                      <></>
                                    )}
                                    {errorData[
                                      personalDetails.fields[arr].field_name
                                    ] === true && (
                                      <p className="text-danger">
                                        Please upload Form 16 document.
                                      </p>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <>
                                <div className={`${nameFields.includes(personalDetails.fields[arr].field_name) ? "col-sm-4 col-md-12 col-xl-2" : "col-sm-4 col-md-12 col-xl-3" }`}>
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        personalDetails.fields[arr].input_type
                                      }
                                      inputName={
                                        personalDetails.fields[arr].field_name
                                      }
                                      inputValue={
                                        personalDetails.fields[arr].value
                                      }
                                      isInputMandatory={
                                        personalDetails.fields[arr].is_mandatory
                                      }
                                      inputLabel={
                                        personalDetails.fields[arr].label
                                      }
                                      countryCodeValue={countryCodeVal}
                                      handleCountryCode={(e) =>
                                        handleCountryCode(e)
                                      }
                                      index={arr}
                                      handleOnChange={(e)=>handleInputChange(e, personalDetails.fields[arr].is_mandatory)}
                                      options={
                                        personalDetails?.fields[arr]?.field_name == "gender" && updatedGenderData ? updatedGenderData :
                                        optionsKey[
                                          personalDetails.fields[arr].field_name
                                        ]
                                          ? optionsKey[
                                              personalDetails.fields[arr]
                                                .field_name
                                            ]
                                          : []
                                      }
                                      setMinorCandidate={(isMinor) =>
                                        setMinorCandidate(isMinor)
                                      }
                                      saveDate={saveDate}
                                      handleFileUpload={handleFileUpload}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                      readOnly={nonEditableFieldsAfterFirstSave.includes(
                                        personalDetails.fields[arr].field_name
                                      ) || (personalDetails.fields[arr].field_name == "uan_number" && !!(personalDetailsData?.data?.isUanVerified == 1 
                                        || profileFieldsData?.data?.isUanVerified == 1
                                        || uanVerificationData?.data?.status == "success" // check for updated status without page refresh
                                        || uanVerificationData?.data?.api_hit_count == 3))
                                        || personalDetails.fields[arr].field_name == "date_of_birth" && personalDetails?.personal_details_completed && (profileFieldsData?.data?.fields[arr]?.value != "" && profileFieldsData?.data?.fields[arr]?.value != null)
                                      }
                                    />
                                    {personalDetails.fields[arr].field_name ==
                                      "email_address" &&
                                      profileFieldsData.data?.isVerifyEmail ==
                                        1 && (
                                        <button
                                          className="btn btn-primary btn-lg btn-block mt-3"
                                          disabled={(profileFieldsData.data?.isEmailVerified ==
                                            1 ||
                                            verifyComplete == true)}
                                          onClick={(e) =>
                                            handleVerify(
                                              personalDetails.fields[arr].value,
                                              e
                                            )
                                          }
                                        >
                                          {(profileFieldsData.data?.isEmailVerified ==
                                            1) ? "Verified" :"Verify"}
                                        </button>
                                      )}
                                    {/* {personalDetails.fields[arr].field_name ==
                                      "email_address" &&
                                    profileFieldsData.data?.isVerifyEmail ==
                                      1 &&
                                    profileFieldsData.data?.isEmailVerified ==
                                      0 ? (
                                      <button
                                        className="btn btn-primary btn-lg btn-block mt-3"
                                        onClick={(e) =>
                                          handleVerify(
                                            personalDetails.fields[arr].value,
                                            e
                                          )
                                        }
                                      >
                                        Verify
                                      </button>
                                    ) : (
                                      ""
                                    )}
                                    {personalDetails.fields[arr].field_name ==
                                      "email_address" &&
                                    profileFieldsData.data?.isVerifyEmail ==
                                      1 &&
                                    (profileFieldsData.data?.isEmailVerified ==
                                      1 ||
                                      verifyComplete == true) ? (
                                      <button
                                        className="btn btn-primary btn-lg btn-block mt-3"
                                        disabled
                                      >
                                        Verified
                                      </button>
                                    ) : (
                                      ""
                                    )} */}
                                    {errorData[
                                      personalDetails.fields[arr].field_name
                                    ] === true &&
                                    personalDetails.fields[arr].field_name !==
                                      "alternate_mobile_no" ? (
                                      personalDetails.fields[arr].value ===
                                        "" ||
                                      personalDetails.fields[arr].value ===
                                        null ? (
                                        <p className="text-danger">
                                          This is a required field.
                                        </p>
                                      ) : (
                                        <p className="text-danger">
                                          Please provide valid input
                                        </p>
                                      )
                                    ) : (
                                      <></>
                                    )}

                                    {personalDetails.fields[arr].field_name ==
                                      "alternate_mobile_no" &&
                                    errorData[
                                      personalDetails.fields[arr].field_name
                                    ] == true ? (
                                      !!(personalDetails.fields[arr].value ===
                                        "" ||
                                      personalDetails.fields[arr].value ===
                                        null) && !userLocalData?.client_id == "411448" ? (
                                        ""
                                      ) : (
                                        <p className="text-danger">
                                          Please provide valid input
                                        </p>
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                {
                                  personalDetails?.fields[arr].field_name ==
                                    "uan_number" &&
                                    (
                                      <div className="col-sm-4 col-md-2 col-xl-2">
                                      <button
                                        className="btn btn-primary btn-lg btn-block"
                                        disabled={!personalDetails?.fields[arr].value 
                                        || errorData[personalDetails?.fields[arr].field_name] === true 
                                        || personalDetailsData?.data?.isUanVerified == 1 
                                        || profileFieldsData?.data?.isUanVerified == 1
                                        || uanVerificationData?.data?.status == "success" // check for updated status without page refresh
                                        || uanVerificationData?.data?.api_hit_count == 3
                                      }
                                        onClick={(e) =>
                                          handleUANVerification(
                                            personalDetails?.fields[arr].value,
                                            e
                                          )
                                        }
                                      >
                                        {(personalDetailsData?.data?.isUanVerified == 1 
                                          || profileFieldsData?.data?.isUanVerified == 1
                                          || uanVerificationData?.data?.status == "success") ? "Verified" :"Verify"}
                                      </button>
                                      </div>
                                    )
                                }
                                </>
                              )}
                            </>
                          );
                        })}
                      </div>
                    );
                  })}

                  {customMappingArray.map((customMappingArr) => {
                    return (
                      <div className="row">
                        {customMappingArr.map((arr) => {
                          return (
                            <>
                              <div className="col-sm-4 col-md-12 col-xl-4">
                                <div className="form-group">
                                  <InputField
                                    inputType={
                                      personalDetails.custom_fields[arr]
                                        .input_type
                                    }
                                    inputName={
                                      personalDetails.custom_fields[arr].slug
                                    }
                                    inputValue={
                                      personalDetails.custom_fields[arr].value
                                    }
                                    isInputMandatory={
                                      personalDetails.custom_fields[arr]
                                        .is_mandatory
                                    }
                                    inputLabel={
                                      personalDetails.custom_fields[arr].label
                                    }
                                    index={arr}
                                    handleOnChange={handleInputChange}
                                    options={
                                      optionsKey[
                                        personalDetails.custom_fields[arr].slug
                                      ]
                                        ? optionsKey[
                                            personalDetails.custom_fields[arr]
                                              .slug
                                          ]
                                        : []
                                    }
                                    isField={false}
                                  />
                                  {errorData[
                                    personalDetails.custom_fields[arr].slug
                                  ] && (
                                    <p className="text-danger">
                                      Please provide valid input
                                    </p>
                                  )}
                                  {errorData[
                                    personalDetails.custom_fields[arr].slug
                                  ] === true ? (
                                    personalDetails.custom_fields[arr].value ===
                                      "" ||
                                    personalDetails.custom_fields[arr].value ===
                                      null ? (
                                      <p className="text-danger">
                                        This is a required field.
                                      </p>
                                    ) : (
                                      <p className="text-danger">
                                        Please provide valid input
                                      </p>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    );
                  })}

                  {personalDetails.custom_fields && (
                    <div className="row">
                      {personalDetails.custom_fields["relation_bank"] && (
                        <EMPRadio
                          name={`relation_bank`}
                          id={`relation_bank`}
                          label={
                            personalDetails.custom_fields["relation_bank"].label
                          }
                          isRequired={
                            personalDetails.custom_fields["relation_bank"]
                              .is_mandatory
                          }
                          errId={`relation_bank`}
                          fieldName={
                            personalDetails.custom_fields["relation_bank"].slug
                          }
                          fieldValue={
                            personalDetails.custom_fields["relation_bank"].value
                          }
                          checkDetailsIndex={"relation_bank"}
                          options={{ Yes: "yes", No: "no" }}
                          handleRadioChange={handleRadioChange}
                          hasError={errorData["relation_bank"]}
                        />
                      )}
                    </div>
                  )}

                  {personalDetails.custom_fields && (
                    <div className="row">
                      {personalDetails.custom_fields["consent"] && (
                        <EMPCheckbox
                          name={`consent`}
                          id={`consent`}
                          label={personalDetails.custom_fields["consent"].label}
                          isRequired={
                            personalDetails.custom_fields["consent"]
                              .is_mandatory
                          }
                          handleCheckboxChange={handleCheckboxChange}
                          // checkDetailsIndex={key}
                          fieldName={
                            personalDetails.custom_fields["consent"].slug
                          }
                          fieldValue={
                            personalDetails.custom_fields["consent"].value
                          }
                          hasError={errorData["consent"]}
                        />
                      )}
                    </div>
                  )}

                  <h6 class="fnt-16 fnt-smi-bld">Additional Details</h6>
                  <div class="row">
                    <div class="col-md-9 form-group">
                      <div class="row">
                        {inputFields &&
                          inputFields.map((data, i) => {
                            return (
                              <div class="col-md-4 form-group">
                                <label for="exampleInputEmail1">
                                  {data.label}
                                  {data.is_mandatory ? (
                                    <sup className="text-danger">*</sup>
                                  ) : (
                                    ""
                                  )}
                                </label>
                                {data.input_type === 4 ? (
                                  <Select
                                    value={
                                      data?.field_name ==
                                        "bridge_location_id" ||
                                      data?.field_name == "cc_email_address"
                                        ? inputFormData[data.field_name]
                                        : inputFormData[data.field_id]
                                    }
                                    // value={inputFormData[data.field_id] || null}
                                    onChange={(codeData) => {
                                      data.checkData = codeData?.label;
                                      const inputData = { ...inputFormData };
                                      if (
                                        data?.field_name == "bridge_location_id"
                                      ) {
                                        inputData[data?.field_name] = codeData;
                                      } else if (
                                        data?.field_name == "cc_email_address"
                                      ) {
                                        inputData[data?.field_name] = codeData;
                                      } else {
                                        inputData[data.field_id] = codeData;
                                      }
                                      setInputFormData(inputData);
                                    }}
                                    options={getDropdownOption(data)}
                                    isSearchable={true}
                                    // placeholder={ (data?.field_name == "bridge_location_id") ?
                                    // `Enter ${data.field_name}` : `Enter ${data.label}`
                                    //   }
                                    placeholder={`Enter ${data.label}`}
                                  />
                                ) : (
                                  <input
                                    type={getInputType[data.input_type]}
                                    value={
                                      data?.field_name ==
                                        "bridge_location_id" ||
                                      data?.field_name == "cc_email_address"
                                        ? inputFormData[data.field_name] || ""
                                        : inputFormData[data.field_id] || ""
                                    }
                                    readOnly={
                                      data?.optionArray?.readonly == "readonly"
                                        ? true
                                        : false
                                    }
                                    class="form-control"
                                    id="exampleInputEmail1"
                                    placeholder={`Enter ${data.label}`}
                                    aria-describedby="emailHelp"
                                    onChange={(e) => {
                                      console.log("field.....new...", data)
                                      if (
                                        data?.field_name == "cc_email_address"
                                      ) {
                                        setErrorData((prevState) => ({
                                          ...prevState,
                                          [data?.field_name]: false,
                                        }));
                                        setEmailErr(
                                          !validateEmail(e.target.value)
                                        );
                                        setErrorData((prevState) => ({
                                          ...prevState,
                                          [data?.field_name]: !validateEmail(
                                            e.target.value
                                          ),
                                        }));
                                        if (e.target.value == "") {
                                          setEmailErr(false);
                                          setErrorData((prevState) => ({
                                            ...prevState,
                                            [data?.field_name]: false,
                                          }));
                                        }
                                      } else if(data?.is_validation_required === 1 && e?.target?.value) {
                                        const currentInput = e?.target?.value
                                        if(!isNaN(currentInput) && currentInput?.length !== 6 ) {
                                          setErrorData((prevState) => ({
                                            ...prevState,
                                            [data?.field_name]: true,
                                          }));
                                        } else if(isNaN(currentInput)) {
                                          setErrorData((prevState) => ({
                                            ...prevState,
                                            [data?.field_name]: true,
                                          }));
                                        } else {
                                          setErrorData((prevState) => ({
                                            ...prevState,
                                            [data?.field_name]: false,
                                          }));
                                        }
                                      }

                                      const inputData = { ...inputFormData };
                                      data.checkData = e.target.value;
                                      if (
                                        data?.field_name == "cc_email_address"
                                      ) {
                                        inputData[data?.field_name] =
                                          e.target.value;
                                      } else {
                                        inputData[data.field_id] =
                                          e.target.value;
                                      }

                                      setInputFormData(inputData);
                                    }}
                                  />
                                )}
                                {errorData[inputFields[i].field_name] ===
                                  true && inputFields[i].is_mandatory ? (
                                  inputFields[i].checkData === "" ||
                                  inputFields[i].checkData === null ? (
                                    <p className="text-danger">
                                      This is a required field.
                                    </p>
                                  ) : data.is_validation_required 
                                  ? (
                                    <p className="text-danger">
                                    Please enter 6 digit ID
                                  </p>
                                  ) :(
                                    ""
                                  )
                                ) : (
                                  <>
                                    {errorData[inputFields[i].field_name] ===
                                      true &&
                                    data?.field_name !== "cc_email_address" ? data.is_validation_required 
                                    ? (
                                      <p className="text-danger">
                                      Please enter 6 digit ID
                                    </p>
                                    ) 
                                    :(
                                      <p className="text-danger">
                                        Please provide valid input
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                )}
                                {emailErr &&
                                data?.field_name == "cc_email_address" ? (
                                  <p className="text-danger">
                                    Please provide valid input
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    <div class="col-md-3 form-group"></div>
                  </div>

                  {
                    !!(personalDetails.other_checks && Object.entries(personalDetails?.other_checks || {}).length) && 
                    <div className="mb-3">
                      <h6 className="fnt-smi-bld mb-1">Other Check Details</h6>
                    </div>
                  }
                  
                  {personalDetails.other_checks && Object.entries(personalDetails?.other_checks || {}).map(checkDetail => {
                    const checkId = checkDetail[0];
                    const checkFieldnDoc = checkDetail[1];
                    console.log("other check detail...", checkDetail[1])
                    return (
                      <>
                      <div className="row">
                        {
                          checkFieldnDoc?.fields && Object.entries(checkFieldnDoc?.fields || {})?.length > 0 && (
                            Object.entries(checkFieldnDoc?.fields)?.map((field, index) => {
                              console.log("fields other details...", field)
                              return (
                                <>
                                  <div className="col-sm-4 col-md-12 col-xl-4">
                                    <div className="form-group">
                                      <InputField
                                        inputType={
                                          field[1].input_type
                                        }
                                        inputName={
                                          field[1].field_name
                                        }
                                        inputValue={
                                          field[1].value
                                        }
                                        isInputMandatory={
                                          field[1].is_mandatory
                                        }
                                        inputLabel={
                                          field[1].label
                                        }
                                        index={index}
                                        handleOnChange={(e)=>handleInputChange(e, field[1].is_mandatory, "other_check", checkId)}
                                        options={
                                          optionsKey[
                                            field[1].field_name
                                          ]
                                            ? optionsKey[
                                            field[1]
                                              .field_name
                                            ]
                                            : []
                                        }
                                        isField={true}
                                        readOnly={nonEditableFieldsAfterFirstSave.includes(
                                          field[1].field_name
                                        )}
                                      />

                                      {errorData[
                                        field[1].field_name
                                      ] === true ? (
                                        field[1].value ===
                                          "" ||
                                          field[1].value ===
                                          null ? (
                                          <p className="text-danger">
                                            This is a required field.
                                          </p>
                                        ) : (
                                          <p className="text-danger">
                                            Please provide valid input
                                          </p>
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                </>
                              )
                            })
                          )
                        }
                      </div>
                      <div className="row">
                        {
                          checkFieldnDoc?.docs && Object.entries(checkFieldnDoc?.docs || {})?.length > 0 && (
                            Object.entries(checkFieldnDoc?.docs)?.map((docField, index) => {
                              console.log("fields other details...", docField)
                              return (
                                <div className="col-sm-4 col-md-12 col-xl-4">
                                  <div className="form-group">
                                    <InputField
                                      inputType={
                                        docField[1].input_type
                                      }
                                      inputName={
                                        docField[1].field_name
                                      }
                                      inputValue={
                                        docField[1].value
                                      }
                                      errorField={docField[1].field_name}
                                      uploadedFilePreview={
                                        docField[1].preview &&
                                        docField[1].preview
                                          .preview_key
                                          ? docField[1].preview
                                              .preview_key
                                          : "n.a."
                                      }
                                      isInputMandatory={
                                        docField[1].is_mandatory
                                      }
                                      inputLabel={
                                        docField[1].label
                                      }
                                      index={index}
                                      handleOnChange={(e)=>handleInputChange(e, docField[1].is_mandatory, "other_check_doc", checkId)}
                                      handleFileUpload={handleFileUpload}
                                      isFileUploadedObject={
                                        isFileUploadedObject
                                      }
                                      isField={true}
                                      hideOtherOption = {true}
                                    />
                                      {/* <small className="text-danger">
                                        Max upload limit - 5mb
                                        <br />
                                        Acceptable formats - jpg, png & jpeg are
                                        preferred
                                      </small> */}
                                    {errorData[
                                      docField[1].field_name
                                    ] === true && (
                                      <p className="text-danger">
                                         This is a required field.
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )
                            })
                          )
                        }
                      </div>
                      </>
                    )

                  })}

                  {/* <h6 class="fnt-16 fnt-smi-bld">Additional Details</h6> */}
                  {/* <div class="row mt-4">
                    <div class="col-md-3">
                    <div class="form-group"><div class="floating-label">
                      <select name="marital_status" id="14" class="form-control" data-title="field">
                        <option value="">Select option</option>
                        <option value="city">Delhi</option>
                        <option value="city">Gurgaon</option>
                        <option value="city">Punjab</option>
                        <option value="city">Haryana</option>
                        <option value="city">Lucknow</option>
                        
                        </select>
                        <label for="14" class="focused">Location<sup class="text-danger">*</sup>
                    </label></div></div>
                    </div>

                    <div class="col-md-3">
                    <div class="form-group"><div class="floating-label">
                      <select name="marital_status" id="14" class="form-control" data-title="field">
                        <option value="">Select option</option>
                        <option value="city">1</option>
                        <option value="city">2</option>
                        <option value="city">3</option>
                        <option value="city">4</option>
                        <option value="city">5</option>
                        
                        </select>
                        <label for="14" class="focused">Employ ID Test<sup class="text-danger">*</sup>
                    </label></div></div>
                    </div>

                    <div class="col-md-3">
                    <div class="form-group"><div class="floating-label">
                      <input type="text" class="form-control" name="Entity_name" id="13" data-title="field" autocomplete="new-password" value="" />
                      <label for="13" class="">Entity Name</label>
                      </div></div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-md-3">
                    <div class="form-group"><div class="floating-label">
                      <select name="marital_status" id="14" class="form-control" data-title="field">
                        <option value="">Select option</option>
                        <option value="city">1</option>
                        <option value="city">2</option>
                        <option value="city">3</option>
                        <option value="city">4</option>
                        <option value="city">5</option>
                        
                        </select>
                        <label for="14" class="focused">Test<sup class="text-danger">*</sup>
                    </label></div></div>
                    </div>

                    <div class="col-md-3">
                    <div class="form-group"><div class="floating-label">
                      <select name="marital_status" id="14" class="form-control" data-title="field">
                        <option value="">Select option</option>
                        <option value="city">1</option>
                        <option value="city">2</option>
                        <option value="city">3</option>
                        <option value="city">4</option>
                        <option value="city">5</option>
                        
                        </select>
                        <label for="14" class="focused">DSP<sup class="text-danger">*</sup>
                    </label></div></div>
                    </div>

                    <div class="col-md-3">
                    <div class="form-group"><div class="floating-label">
                      <input type="text" class="form-control" name="Entity_name" id="13" data-title="field" autocomplete="new-password" value="" />
                      <label for="13" class="">Client Name</label>
                      </div></div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-md-3">
                    <div class="form-group"><div class="floating-label">
                      <select name="marital_status" id="14" class="form-control" data-title="field">
                        <option value="">Select option</option>
                        <option value="city">1</option>
                        <option value="city">2</option>
                        <option value="city">3</option>
                        <option value="city">4</option>
                        <option value="city">5</option>
                        
                        </select>
                        <label for="14" class="focused">Location<sup class="text-danger">*</sup>
                    </label></div></div>
                    </div>

                    <div class="col-md-3">
                    <div class="form-group"><div class="floating-label">
                      <select name="marital_status" id="14" class="form-control" data-title="field">
                        <option value="">Select option</option>
                        <option value="city">1</option>
                        <option value="city">2</option>
                        <option value="city">3</option>
                        <option value="city">4</option>
                        <option value="city">5</option>
                        
                        </select>
                        <label for="14" class="focused">Priority<sup class="text-danger">*</sup>
                    </label></div></div>
                    </div>

                  </div> */}
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      {profileFieldsData.data?.isVerifyEmail == 0 ||
                      profileFieldsData.data?.isEmailVerified == 1 ||
                      verifyEmailData.status == "success" ? (
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          // onClick={(e) => checkBeforeSave1(e)}
                          onClick={(e) => SubmitPopup(e)}
                        >
                          Save
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          disabled
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {personalDetails.showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                          {clientId == 459831 ? "Preview" : "Submit for Preview"}
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                  )}
                </form>
                <Footer />
              </div>
            </div>
          </div>
        )}

        {isDuplicateModal && (
          <div class="custom-modal-dialog  duplicate-modal d-block">
            <div class="custom-modal-wrapper">
              <div class="custom-modal-content bg-gray p-3 h-inherit select-package">
                <h5 class="border-red">
                  <i data-feather="alert-triangle">
                    <FeatherIcon icon="info" />
                  </i>
                  <h6 className="border-red fnt-18 mt-4">
                    {duplicateCase.length} Duplicate / Matching Record(s) found!
                  </h6>
                  <p
                    className="fnt-14 text-gray mt-1"
                    style={{ fontSize: "12px" }}
                  >
                    These record(s) might be a duplicate of an existing record.
                    Review and update{" "}
                  </p>
                </h5>

                <div class="duplicate_content">
                  <h5 className="fnt-12 text-blue-2 mt-4 ml-2">Duplicate #1</h5>
                  <div className="bg-gray p-2 duplicate">
                    <h6 class="fnt-12 fnt-smi-bld">You’ve Entered</h6>
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr class="bg-gray tr-th-fnt-14">
                            <th className="fnt-nrml">Name</th>
                            <th className="fnt-nrml">Phone</th>
                            <th className="fnt-nrml">Email address</th>
                           {duplicateCase[0]?.flex_field_name ? <th className="fnt-nrml">{duplicateCase[0]?.flex_field_name}</th>:<></>}
                            <th className="fnt-nrml" width="140">
                              Date of Birth
                            </th>
                            <th className="fnt-nrml" width="140">
                              Initiate date
                            </th>
                          </tr>
                        </thead>
                        <tr class="bg-light-blue">
                          <td className="fnt-smi-bld">
                            {
                              `${personalDetails?.fields[1] ? personalDetails?.fields[1]?.value : ""} ${personalDetails?.fields[3] ? personalDetails?.fields[3]?.value : ""}`
                            }
                          </td>
                          <td>{personalDetails?.fields[9] ? personalDetails?.fields[9]?.value : ""}</td>
                          <td>{personalDetails?.fields[5] ? personalDetails?.fields[5]?.value : ""}</td>
                         {duplicateCase[0]?.flex_field_value ? <td>{duplicateCase[0]?.flex_field_value}</td>:<></>}
                          <td width="140">
                            {
                              personalDetails?.fields[7] && new Date(personalDetails?.fields[7]?.value || "") ==
                              "Invalid date"
                                ? personalDetails.fields[7].value
                                : moment(
                                    personalDetails.fields[7].value,
                                    "DD-MM-YYYY"
                                  ).format("DD/MM/YYYY")
                              // ? dateFormat(
                              //     "DD/MM/YYYY",
                              //     personalDetails.fields[7].value
                              //   )
                              // : ""
                            }
                          </td>
                          <td width="140">
                            {dateFormat("DD/MM/YYYY", new Date())}
                          </td>
                        </tr>
                      </table>
                    </div>

                    <h6 class="fnt-14 fnt-smi-bld">
                      {duplicateCase.length} Matching Records Found
                    </h6>
                    <div class="table-responsive dp">
                      <table class="table">
                        <tr class="bg-gray tr-th-fnt-14">
                          <th className="fnt-nrml">Name</th>
                          <th className="fnt-nrml">Phone</th>
                          <th className="fnt-nrml">Email address</th>
                          {duplicateCase[0]?.flex_field_name ? <th className="fnt-nrml">{duplicateCase[0]?.flex_field_name}</th>:<></>}
                          <th className="fnt-nrml" width="140">
                            Date of Birth
                          </th>
                          <th className="fnt-nrml" width="140">
                            Initiate date
                          </th>
                        </tr>
                        {duplicateCase.map((data) => {
                          return (
                            <tr>
                              <td className="fnt-smi-bld">
                                {data.first_name + " " + data.last_name}
                              </td>
                              <td>{data.mobile_no}</td>
                              <td>{data.email_address}</td>
                             {data?.flex_field_value ?  <td>{data?.flex_field_value}</td>:<></>}
                              <td width="140">
                                {new Date(data.date_of_birth) == "Invalid date"
                                  ? data.date_of_birth
                                  : data.date_of_birth
                                  ? dateFormat("DD/MM/YYYY", data.date_of_birth)
                                  : ""}
                              </td>
                              <td width="140">
                                {new Date(data.created_on) == "Invalid date"
                                  ? data.created_on
                                  : data.created_on
                                  ? dateFormat("DD/MM/YYYY", data.created_on)
                                  : ""}
                              </td>
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                    {/* <div class="mb-2">
                      <button
                        type="button"
                        class="btn btn-clear"
                        data-dismiss="modal"
                      >
                        Discard Case
                      </button>
                      <button type="button" class="btn btn-primary ml-3">
                        Ignore Duplicates{" "}
                      </button>
                    </div> */}
                  </div>
                  {/* <h3 className="fnt-12 text-blue-2 mt-4">Duplicate #1</h3>
                  <div className="bg-gray p-2 duplicate">
                    <h4 class="fnt-14 fnt-smi-bld">Entered details</h4>
                    <div class="table-responsive">
                      <table class="table">
                        <tr class="bg-gray">
                          <td width="150">Name</td>
                          <td width="100">Phone</td>
                          <td width="150">Email address</td>
                          <td>Date of Birth</td>
                          <td>Initiate date</td>
                        </tr>
                        <tr class="bg-light-blue">
                          <td>Kirti Azaad</td>
                          <td>9990664646</td>
                          <td>Azaad@authb.com</td>
                          <td>7 Dec 1943</td>
                          <td>12 Dec 2022</td>
                        </tr>
                      </table>
                    </div>

                    <h4 class="fnt-14 fnt-smi-bld">2 Matching Records Found</h4>
                    <div class="table-responsive dp">
                      <table class="table">
                        <tr class="bg-gray">
                          <td width="150">Name</td>
                          <td width="100">Phone</td>
                          <td>Email address</td>
                          <td>Date of Birth</td>
                          <td>Initiate date</td>
                        </tr>
                        <tr>
                          <td>Kirti Azaad</td>
                          <td>9990664646</td>
                          <td>Azaad@authb.com</td>
                          <td>7 Dec 1943</td>
                          <td>12 Dec 2022</td>
                        </tr>
                      </table>
                    </div>
                    <div class="mb-2">
                      <button
                        type="button"
                        class="btn btn-clear"
                        data-dismiss="modal"
                      >
                        Discard Case
                      </button>
                      <button type="button" class="btn btn-primary ml-3">
                        Ignore Duplicates{" "}
                      </button>
                    </div>
                  </div> */}
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-secondary light-blue w-100"
                    data-dismiss="modal"
                    onClick={(event) => {
                      event.preventDefault();
                      discardCase();
                    }}
                  >
                    Discard
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary w-100"
                    onClick={(event) => {
                      event.preventDefault();
                      ignoreDuplicate();
                    }}
                  >
                    Ignore Duplicate{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};
export default CandidatePersonalDetailByClient;